// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-day-trip-booking{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:0 0 0 auto;font-weight:var(--font-weight-medium);vertical-align:bottom}@media (min-width:768px){.h-day-trip-booking{min-width:120px;height:52px;margin-left:auto}}@media (max-width:767px){.h-day-trip-booking.h-btn{width:auto;padding-left:10px;-webkit-box-shadow:none;box-shadow:none}}", ""]);
// Exports
module.exports = exports;
